import { useEffect, useRef, useState } from "react";
import { DDiffLaureatesAnimatedExhibitProps } from "./types/ddiff-laureates-animated-exhibit-types";
import ImageCTAMeatball from "components/utility/images/ImageCTAMeatball";
import {
	observeLaureatesAnimatedExhibit,
	disconnectLaureatesAnimatedExhibitObserver
} from "utils/ddiff-animations/laureatesAnimatedExhibitObserver";
import { getDecodedHtml } from "utils/getDecodedHtml";
import { isMobile } from "components/utility/page-responsive/PageResponsive";

const DDiffLaureatesAnimatedExhibit = ({ data }: DDiffLaureatesAnimatedExhibitProps) => {
	const title = data?.Title;
	const cards = data?.cards;
	const [buttonExpand, setButtonExpand] = useState<string>("");
	const [mobileLayout, setMobileLayout] = useState<boolean>(false);
	const descriptionContainer = useRef<HTMLDivElement>(null);
	const componentContainer = useRef<HTMLDivElement>(null);

	const handleExpandCollapse = () => {
		if (buttonExpand === "expand") {
			setButtonExpand("collapse");
		}
		if (buttonExpand === "" || buttonExpand === "collapse") {
			setButtonExpand("expand");
		}
	};

	useEffect(() => {
		const manageMobileState = () => {
			if (isMobile()) {
				disconnectLaureatesAnimatedExhibitObserver();
				setMobileLayout(true);
			} else {
				observeLaureatesAnimatedExhibit(componentContainer.current);
				setMobileLayout(false);
			}
		};
		manageMobileState();
		window.addEventListener("resize", manageMobileState);
		return () => {
			disconnectLaureatesAnimatedExhibitObserver();
			window.removeEventListener("resize", manageMobileState);
		};
	});
	return (
		<>
			<div
				className="ddiff-laureates-animated-exhibit ddiff-laureates-animation"
				ref={componentContainer}
			>
				<div className="title t-label-sm-heavy tc-cool-gray-01">{title}</div>
				<div className="laureate-info-container">
					{mobileLayout ? (
						<>
							{cards?.map((card) => (
								<div className="laureate-card" key={"mobile-card-" + card.id}>
									<div className="laureate-image-placard">
										<img src={card.media.imageUrl} alt={card.media.imageAlt}></img>
										<div className="laureate-image-placard-info">
											<div className="name t-body-xs-heavy ">{card.name}</div>
											<div className="award-and-date t-body-xs-italic tc-cool-gray-02">
												{card.awardDate}
											</div>
										</div>
									</div>
									<div className="laureate-description">
										<div
											className="laureate-description-text t-body-xs"
											dangerouslySetInnerHTML={{ __html: getDecodedHtml(card.description) }}
										/>
									</div>
								</div>
							))}
						</>
					) : (
						<>
							<div className="top-row">
								<button
									className={`expand-description-button ${buttonExpand}`}
									onClick={handleExpandCollapse}
									data-a-evt="Subcontent view"
									data-a-comp="Laureates Animated Exhibit"
									aria-label="Expand laureate descriptions"
								>
									<div className="cta-meatball-icon">
										<ImageCTAMeatball />
									</div>
								</button>
								<div className="top-row-content">
									{cards?.map((card) => (
										<div className="laureate-image-placard" key={"placard-" + card.id}>
											<img src={card.media.imageUrl} alt={card.media.imageAlt}></img>
											<div className="name t-body-xs-heavy ">{card.name}</div>
											<div className="award-and-date t-body-xs-italic tc-cool-gray-02">
												{card.awardDate}
											</div>
										</div>
									))}
								</div>
							</div>
							<div className={`bottom-row `}>
								<div
									className={`laureate-description-container ${buttonExpand}`}
									ref={descriptionContainer}
								>
									{cards?.map((card) => (
										<div className={`laureate-description `} key={"description-" + card.id}>
											<div
												className="laureate-description-text t-body-xs"
												dangerouslySetInnerHTML={{ __html: getDecodedHtml(card.description) }}
											/>
										</div>
									))}
								</div>
							</div>
						</>
					)}
				</div>
			</div>
		</>
	);
};

export default DDiffLaureatesAnimatedExhibit;
